/**
 * PhaseNode component
 * Special node representing a phase category in the phase layout
 * Simplified design to act more like a title
 */

import React, { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { cn } from '@/lib/utils';
import { PhaseNodeData } from '@/types/phaseTypes';

/**
 * PhaseNode component
 */
const PhaseNode = ({ data, selected }: NodeProps) => {
  const nodeData = data as unknown as PhaseNodeData;
  const { name, color, childCount } = nodeData;
  
  // Fixed dimensions for title-like appearance
  const nodeWidth = nodeData.width || 280;
  
  return (
    <div className={cn(
      "transition-transform duration-200 relative", 
      selected && "scale-[1.02]"
    )}>
      {/* 左右のハンドルのみ表示 - 接続不可能に設定 */}
      <Handle type="target" position={Position.Left} className="w-2 h-2" isConnectable={false} />
      <Handle type="source" position={Position.Right} className="w-2 h-2" isConnectable={false} />
      
      <div 
        className={cn(
          "flex items-center justify-between rounded-lg px-4 py-2",
          "bg-background/50 backdrop-blur-sm",
          "border border-solid",
          selected ? "ring-2 ring-offset-1" : ""
        )}
        style={{ 
          width: `${nodeWidth}px`,
          borderColor: color,
          borderLeftWidth: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}
      >
        <div 
          className="text-lg font-bold"
          style={{ color }}
        >
          {name}
        </div>
        <div className="text-xs px-2 py-0.5 bg-muted rounded-full text-muted-foreground">
          {childCount}
        </div>
      </div>
    </div>
  );
};

export default memo(PhaseNode);